<!-- eslint-disable -->
<template lang="pug">
    div(v-if="errorStatus === 403")
        | {{ $i18n.t('common.common_textInfo_pageNotAllowed') }}
    profile-preview(v-else-if="!isLoading && course")
        template(slot="left")
            svg-icon.profile__avatar(name="book" height="80px" width="80px")
            .profile__name
                | {{ course.name }}
            .profile__items
                .profile__box
                    .profile__item.profile__item--size
                        svg-icon.profile__icon.profile__icon--small(
                            v-if="course.status === 'active'",
                            name="check",
                            height="18px",
                            width="14px"
                        )
                        svg-icon.profile__icon.profile__icon--small(
                            v-else
                            name="times"
                            size="small"
                        )
                        .profile__text
                            .profile__text--header {{ $i18n.t('profiles.profiles_profile_status') }}
                            div {{ statusString }}
                    .profile__item.profile__item--size(v-if="user.isSuperadmin || user.type ==='admin' || user.isManagerOrSupport")
                        svg-icon.profile__icon(name="calendar-list", size="large")
                        .profile__text
                            .profile__text--header {{ $i18n.t('profiles.profiles_course_dateCreating') }}
                            div {{ course.createdAt | moment('DD.MM.YYYY') }}
                    .profile__item.profile__item--size(v-if="user.isSuperadmin || user.isManagerOrSupport")
                        svg-icon.profile__icon(name="list-inverse", size="large")
                        .profile__text
                            .profile__text--header {{ $i18n.t('profiles.profiles_course_grades') }}
                            div
                                | {{ course.amountOfGrades }}
                                | {{ $i18n.t('profiles.profiles_course_active') }}
                                | /
                                | {{ course.amountOfAllGrades }}
                                | {{ $i18n.t('profiles.profiles_course_total') }}
                    .profile__item.profile__item--size(v-if="user.isSuperadmin || user.isManagerOrSupport")
                        svg-icon.profile__icon(name="profile", size="large")
                        .profile__text
                            .profile__text--header  {{ $i18n.t('profiles.profiles_course_students') }}
                            div
                                | {{ course.amountOfStudents }}
                                | {{ $i18n.t('profiles.profiles_course_active') }}
                                | /
                                | {{ course.amountOfAllStudents }}
                                | {{ $i18n.t('profiles.profiles_course_total') }}
        template(slot="right")
            .info__buttons(v-if="isShowButton")
                cs-button.info__button(
                    @click="$router.push({name: 'course:edit', params: {id: course.id}})"
                    color="green"
                    pattern="primary-outline"
                )
                    | {{ $i18n.t('profiles.profiles_profile_edit') }}
            .info__item
                .info__item-header
                    | {{ $i18n.t('profiles.profiles_course_description') }}
                hr.info__divider
                .course__description {{ course.description }}
    cs-loader(v-else)
</template>

<script>
    /*eslint-disable*/
    import CourseApi from '../../api/course';
    import {mapState} from 'vuex'
    import _ from 'lodash'
    import ProfilePreview from './ProfilePreview.vue'

    export default {
        data() {
            return {
                course: null,
                isLoading: false,
                errorStatus: null
            }
        },
        props: ['id'],
        mounted() {
            this.fetchData();
        },
        computed: mapState({
            user: state => state.auth.user,
            statusString () {
                return this.$i18n.t('profiles.profiles_profile_status' + _.capitalize(this.course.status))
            },
            isShowButton () {
                return this.user.isSuperadmin || this.user.isManagerOrSupport;
            }
        }),
        methods: {
            fetchData() {
                this.isLoading = true;
                CourseApi.show(this.id)
                .then(data => {
                    this.course = data;
                    this.isLoading = false;
                })
                .catch(err => {
                    this.errorStatus = err.status;
                    this.isLoading = false;
                })
            }
        },
        components: {
            ProfilePreview,
        }
    }
</script>

<style lang="scss" scoped>
    .profile__avatar {
        color: $x-color-white;
    }

    .profile__name {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        color: $x-color-white;
        margin: 20px 0 30px;
        text-align: center;
    }

    .profile__items {
        width: 100%;
    }

    .profile__box {
        display: flex;
        flex-wrap: wrap;
        margin: 0 auto;

        max-width: 240px;
        @include media($md) {
            max-width: 100%;
        }
        @include media($xlg) {
            max-width: 240px;
        }
    }

    .profile__send-message-container {
        display: flex;
        justify-content: center;
        width: 100%;
    }

    .profile__send-message {
        max-width: 240px;
    }

    .profile__item {
        box-sizing: border-box;
        padding: 0;
        color: $x-color-white;
        display: flex;
        font-size: 18px;
        line-height: 24px;
        margin-top: 34px;
    }


    .profile__item--size {
        width: 100%;
        @include media($md) {
            width: 50%;
            &:nth-child(odd) {
                padding-right: 20px;
            }
        }
        @include media($xlg) {
            width: 100%;
        }
    }

    .profile__icon {
        padding-top: 5px;
        margin-right: 10px;
    }

    .profile__icon--small {
        margin-right: 16px;
    }

    .profile__text {
        display: flex;
        flex-direction: column;
    }

    .profile__text--header {
        font-weight: 500;
    }

    .profile__link {
        font-size: 18px;
        line-height: 26px;
        color: $x-color-white;
        text-decoration-line: underline;
    }

    .info__buttons {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        margin: 20px 0;
        @include media($lg) {
            margin: 0 0 20px;
            flex-direction: row;
            justify-content: flex-end;
        }
    }

    .info__button {
        margin-bottom: 10px;
        @include media($lg) {
            margin-left: 10px;
        }
    }

    .info__item {
        padding: 30px;
        box-sizing: border-box;
        background-color: $hsl-color-gray-98;
        border-radius: $border-radius-20;

        display: flex;
        flex-direction: column;
        justify-content: space-between;

        margin-bottom: 0;
        &:not(:last-child) {
            margin-bottom: 30px;
        }
    }

    .info__item-header {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        display: flex;
        align-items: center;
    }

    .info__item-header--light {
        margin-left: 1rem;
        color: $hsl-color-gray-74;
    }

    .info__divider {
        border: 0;
        margin: 25px auto 0;
        background: $hsl-color-gray-74;
        height: 1px;
        width: 100%;
        &:last-child {
            display: none;
        }
    }

    .main-contact, .admin, .teacher, .student {
        display: flex;
        box-sizing: border-box;
        margin-top: 30px;
    }

    .course {
        display: flex;
        box-sizing: border-box;
        margin-top: 30px;
        &:nth-child(odd) {
            padding-right: 20px;
        }
    }

    .course__info, .lesson__info {
        font-size: 16px;
        line-height: 24px;
        color: $x-color-black;
    }

    .course__icon {
        color: $hsl-color-green-58;
        margin-right: 15px;
    }

    .course__description {
        margin-top: 30px;
    }

    .course__name, .billing__link {
        color: $hsl-color-blue-56;
        text-decoration: underline;
        &:hover {
            color: $hsl-color-blue-56;
            text-decoration: none;
        }
    }

    .lessons__empty {
        margin-top: 30px;
    }

    .lesson {
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        margin-top: 30px;
        &:not(:last-child) {
            margin-bottom: 30px;
        }
    }

    .students__button {
        font-weight: 500;
        font-size: 18px;
        line-height: 21px;
        display: flex;
        align-items: center;
        margin-top: 30px;
    }

    .angle__icon {
        margin-left: 10px;
        color: $hsl-color-blue-56;
    }

    .angle__icon--inverse {
        transform: rotate(0.5turn);
    }

    .grade {
        display: flex;
        align-items: center;
    }

    .grade__avatar {
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        max-height: none;
        height: 60px;
        width: 60px;
        margin-right: 12px;
        color: $hsl-color-green-58;
        background: $hsl-color-gray-95;
        border: 1px solid $x-color-gray-5;
        box-sizing: border-box;
    }

    .grade__name {
        color: $hsl-color-blue-56;
        text-decoration: none;
        &:hover {
            color: $hsl-color-blue-56;
            text-decoration: none;
        }
    }
</style>
